module.exports = __webpack_public_path__ + "img/ic_map-1.54b6cc40.svg";